import { WheelEvent } from "react";

const handleWheel = (event: WheelEvent<HTMLInputElement>) => {
  event.currentTarget.blur();
};
export default handleWheel;
